<template>
  <section class="mobile-header-root">
    <div class="filters">
      <filter-select
        title="Откуда"
        modal-title="Выбор региона погрузки"
        :items="loadPoints"
        @set-filter="setLoadFilter"
      />
      <filter-select
        title="Куда"
        modal-title="Выбор пункта выгрузки"
        :items="unloadPoints"
        @set-filter="setUnloadFilter"
      />
      <filter-select
        title="Тип перевозки"
        modal-title="Выбор типа перевозки"
        :items="typeCodesFilters"
        @set-filter="setTypeFilter"
      />
    </div>
    <div class="view-type">
      <div
        :class="['view-type__button', { active: showFutureFlights }]"
        @click="toggleButton()"
      >
        <p>Будущие</p>
      </div>
      <div
        :class="['view-type__button', { active: !showFutureFlights }]"
        @click="toggleButton()"
      >
        Прошедшие
      </div>
    </div>
  </section>
</template>

<script>
import { getNow } from '@/helpers/date'
import { typeCodesFilters } from '@/datas/consts'
import FilterSelect from '@/components/Drivers/FilterSelect/FilterSelect'

export default {
  name: 'FlightsFilter',
  components: {
    FilterSelect,
  },
  props: {
    flights: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loadFilterValue: [],
      unloadFilterValue: [],
      typeFilterValue: '',
      showFutureFlights: true,
      typeCodesFilters,
    }
  },
  computed: {
    // список регионов отправки для фильтра
    loadPoints() {
      let allPoints = this.flights.map(item => ({
        label: item.load_point_region_id,
        title: item.load_point.split(',')[0],
      }))
      let uniquePoints = []

      allPoints.filter(item =>
        uniquePoints.find(uniqe => uniqe.label === item.label)
          ? false
          : uniquePoints.push(item),
      )

      return uniquePoints
    },
    // список мест выгрузки для фильтра
    unloadPoints() {
      let allPoints = this.flights.map(item => ({
        label: item.unload_point_city_id,
        title: item.unload_point.split(',')[1],
      }))
      let uniquePoints = []

      allPoints.filter(item =>
        uniquePoints.find(uniqe => uniqe.label === item.label)
          ? false
          : uniquePoints.push(item),
      )

      return uniquePoints
    },
    // строка фильтров для запроса
    actualFilterState() {
      let res = ''
      if (this.loadFilterValue.length) {
        res += `&load_point_region_id=${this.loadFilterValue.join(',')}`
      }
      if (this.unloadFilterValue.length) {
        res += `&unload_point_city_id=${this.unloadFilterValue.join(',')}`
      }
      if (this.typeFilterValue.length) {
        res += `&type_code=${this.typeFilterValue}`
      }
      const today = getNow('YYYY-MM-DD')
      res += this.showFutureFlights ? '&date_from=' + today : '&date_to=' + today

      return '?' + res.slice(1)
    },
  },
  methods: {
    toggleButton() {
      this.showFutureFlights = !this.showFutureFlights
      this.$emit('filter-changed', this.actualFilterState)
    },
    setLoadFilter(result) {
      this.loadFilterValue = result
      this.$emit('filter-changed', this.actualFilterState)
    },
    setUnloadFilter(result) {
      this.unloadFilterValue = result
      this.$emit('filter-changed', this.actualFilterState)
    },
    setTypeFilter(result) {
      if (result.length === this.typeCodesFilters.length || !result.length) {
        this.typeFilterValue = ''
      } else {
        this.typeFilterValue = result[0]
      }
      this.$emit('filter-changed', this.actualFilterState)
    },
  },
}
</script>

<style lang="sass" scoped>
.mobile-header-root
  position: fixed
  top: 0
  left: 0
  right: 0
  z-index: 100
  background: transparent

  .filters
    display: flex
    justify-content: space-between
    align-items: center
    height: 6.2rem
    padding: 0 1.6rem
    background: #FFFFFF
    box-shadow: 0 0 2rem rgba(132, 132, 132, 0.2)

  .view-type
    display: flex
    justify-content: space-between
    align-items: center
    height: 4.2rem
    margin: 1.5rem 1.6rem 0
    padding: 0 .4rem
    background: #FFFFFF
    border-radius: .8rem
    box-shadow: 0px 0px 10px rgba(132, 132, 132, 0.15)

    &__button
      display: flex
      justify-content: center
      align-items: center
      width: 16.4rem
      height: 3.4rem
      font-size: 1.4rem
      font-weight: 700
      line-height: 1.8rem
      border: none
      border-radius: .8rem
      background: #FFFFFF
      color: #5C5C5C
      cursor: pointer
      &:hover
        background: #00833C
        color: #FFFFFF
      &:active
        color: #FFFFFF
        background: #006421

      &.active
        background: $mainColor
        color: #FFFFFF
</style>
